module.exports = __webpack_public_path__ + "media/trigo.9881495e.mp4";